"use client";

import loadable from "@loadable/component";
import { IconType } from "react-icons";

export type TIcon = {
  icon: string;
  className?: string;
  size?: number;
};

// loaders retornam diretamente o componente do ícone
const iconLoaders: Record<string, (icon: string) => Promise<IconType>> = {
  fa: async (icon) => {
    const mod = await import("react-icons/fa6");
    return mod[icon as keyof typeof mod] as IconType;
  },
  lu: async (icon) => {
    const mod = await import("react-icons/lu");
    return mod[icon as keyof typeof mod] as IconType;
  },
  md: async (icon) => {
    const mod = await import("react-icons/md");
    return mod[icon as keyof typeof mod] as IconType;
  },
  io: async (icon) => {
    const mod = await import("react-icons/io5");
    return mod[icon as keyof typeof mod] as IconType;
  },
  hi: async (icon) => {
    const mod = await import("react-icons/hi");
    return mod[icon as keyof typeof mod] as IconType;
  },
  fc: async (icon) => {
    const mod = await import("react-icons/fc");
    return mod[icon as keyof typeof mod] as IconType;
  },
  ai: async (icon) => {
    const mod = await import("react-icons/ai");
    return mod[icon as keyof typeof mod] as IconType;
  },
  tb: async (icon) => {
    const mod = await import("react-icons/tb");
    return mod[icon as keyof typeof mod] as IconType;
  }
};

export const Icon: React.FC<TIcon> = ({ icon, size, className }) => {
  const prefix = icon.slice(0, 2).toLowerCase();
  const loadIcon = iconLoaders[prefix];

  if (!loadIcon) {
    console.warn(`Prefixo de ícone não suportado: ${prefix}`);
    return null;
  }

  const DynamicIconComponent = loadable(() => loadIcon(icon));

  return <DynamicIconComponent size={size} className={className} />;
};
